module.exports = __webpack_public_path__ + "img/eyes_female_extra_thin.1d322a63.png";